import { Box, Button, Divider, FlexBox, Icon, Link, Typography, Ul } from '@vp/swan'
import { useMyAccountResourcesContent } from '@vp/my-account-pages-dropdown'
import { useFeatureGate } from '../../../hooks/useFeatureGate'
import { useAuth } from '../../../hooks/useAuth'
import { useI18n } from '../../../context/TranslationContext'
import { getHeaderTracker } from '../../../tracking'
import { toSWANIconType } from '../../../utils/swan-icon-converter'

export const MyAccountGuestPop: React.FC = () => {
  const { enabled: isFeatureEnabled } = useFeatureGate()
  const redesignSignInFlyoutEnabled = isFeatureEnabled('redesign_signin_flyout')

  if (!redesignSignInFlyoutEnabled) {
    return <NewPopUpContent />
  }

  return <PopUpContent />
}

const PopUpContent: React.FC = () => {
  const { signIn } = useAuth()
  const { content, isLoading } = useMyAccountResourcesContent()
  const { translate } = useI18n()
  const signedOut = content?.signedOut
  const signInLabel = isLoading ? undefined : (signedOut?.header.signInButtonText ?? translate('signIn'))

  const handleTrackOrderClick = () => {
    getHeaderTracker().trackLink({ navigationDetailPath: ['MyAccount', 'Find and Track an Order'], href: signedOut?.footer.url })
  }

  return (
    <Box m={7} style={{ maxWidth: '340px' }}>
      {signedOut?.body.text && <Typography>{signedOut.body.text}</Typography>}
      <Button mt={7} skin="primary" width="full-width" onClick={signIn}>
        {signInLabel}
      </Button>
      <Divider my={7}></Divider>
      {signedOut?.footer && (
        <FlexBox justifyContent="center">
          <FlexBox flexDirection="row" alignItems="center">
            <FlexBox alignItems="center" color="icon-standard">
              <Icon iconType={toSWANIconType(signedOut.footer.iconType, 'orderSearch')} skin="standard" aria-hidden="true" />
            </FlexBox>
            <Link onClick={handleTrackOrderClick} skin="unstyled" href={signedOut.footer.url} fontSkin="body-small-bold" ml="7">
              {signedOut.footer.text}
            </Link>
          </FlexBox>
        </FlexBox>
      )}
    </Box>
  )
}

const NewPopUpContent: React.FC = () => {
  const { signIn, signUp } = useAuth()
  const { content, isLoading } = useMyAccountResourcesContent()
  const { translate } = useI18n()
  const signedOut = content?.signedOut
  const signInLabel = isLoading ? undefined : (signedOut?.header.signInButtonText ?? translate('signIn'))
  const newHereLabel = isLoading ? undefined : (signedOut?.header.text ?? translate('newHere'))
  const createAccountLabel = isLoading ? undefined : (signedOut?.header.linkText ?? translate('createAccount'))

  const handleTrackOrderClick = () => {
    getHeaderTracker().trackLink({ navigationDetailPath: ['MyAccount', 'Find and Track an Order'], href: signedOut?.footer.url })
  }

  return (
    <FlexBox p={6} flexDirection="column" gap="to-actions" style={{ maxWidth: '256px' }}>
      <FlexBox gap="between-actions" flexDirection="column">
        <Button skin="primary" width="full-width" onClick={signIn}>
          {signInLabel}
        </Button>
        <FlexBox fontSkin="body-small" flexWrap="wrap" gap={2} alignItems="end" justifyContent="center">
          {newHereLabel}
          <Button onClick={signUp} skin="link" fontSkin="body-small" color="body-standard" display="flex">
            {createAccountLabel}
          </Button>
        </FlexBox>
      </FlexBox>
      {signedOut?.body.list && (
        <Ul skin="minimal">
          {signedOut.body.list.map(({ iconType, text }) => (
            <FlexBox key={text} as="li" alignItems="start" gap="between-icon-and-text" fontSkin="body-standard" color="black">
              <Box color="icon-standard">
                <Icon iconType={toSWANIconType(iconType, 'check')} skin="standard" size="standard" />
              </Box>
              <Typography>{text}</Typography>
            </FlexBox>
          ))}
        </Ul>
      )}
      <Divider />
      {signedOut?.footer && (
        <FlexBox justifyContent="center">
          <FlexBox alignItems="center" gap="between-icon-and-text">
            <FlexBox alignItems="center" color="icon-standard">
              <Icon iconType={toSWANIconType(signedOut.footer.iconType, 'orderSearch')} skin="standard" aria-hidden="true" />
            </FlexBox>
            <Link onClick={handleTrackOrderClick} href={signedOut.footer.url} skin="unstyled" fontSkin="body-small-bold" color="body-standard">
              {signedOut.footer.text}
            </Link>
          </FlexBox>
        </FlexBox>
      )}
    </FlexBox>
  )
}
